module.exports = __webpack_public_path__ + "static/media/404.f89561d9.png";